import data from '../../data/menu';
//import { router } from '../../main';

const state = {
    // use mapState to access state from components in 'computed'
    menuItems: data
}

const getters = {
    getPopular: state => state.menuItems.filter(item => item.popular == true),
    getAppetisers: state => state.menuItems.filter(item => item.type.toLowerCase() === "appetisers"),
    getSoups: state => state.menuItems.filter(item => item.type.toLowerCase() === "soups"),
    getMandarin: state => state.menuItems.filter(item => item.type.toLowerCase() === "mandarin dishes"),
    getKungPo: state => state.menuItems.filter(item => item.type.toLowerCase() === "kung po"),
    getSichuan: state => state.menuItems.filter(item => item.type.toLowerCase() === "sichuan"),
    getBlackPepper: state => state.menuItems.filter(item => item.type.toLowerCase() === "black pepper"),
    getBlackBean: state => state.menuItems.filter(item => item.type.toLowerCase() === "black bean"),
    getHoneyChilli: state => state.menuItems.filter(item => item.type.toLowerCase() === "honey & chilli"),
    getHoneyGarlic: state => state.menuItems.filter(item => item.type.toLowerCase() === "honey & garlic"),
    getSweetChilli: state => state.menuItems.filter(item => item.type.toLowerCase() === "sweet chilli"),
    getSatay: state => state.menuItems.filter(item => item.type.toLowerCase() === "satay"),
    getChicken: state => state.menuItems.filter(item => item.type.toLowerCase() === "chicken"),
    getBeef: state => state.menuItems.filter(item => item.type.toLowerCase() === "beef"),
    getKingPrawn: state => state.menuItems.filter(item => item.type.toLowerCase() === "king prawn"),
    getRoastDuck: state => state.menuItems.filter(item => item.type.toLowerCase() === "roast duck"),
    getCharSiu: state => state.menuItems.filter(item => item.type.toLowerCase() === "char siu"),
    getSweetAndSour: state => state.menuItems.filter(item => item.type.toLowerCase() === "sweet and sour"),
    getCurry: state => state.menuItems.filter(item => item.type.toLowerCase() === "curry"),
    getFooYoung: state => state.menuItems.filter(item => item.type.toLowerCase() === "foo young"),
    getFriedRice: state => state.menuItems.filter(item => item.type.toLowerCase() === "fried rice"),
    getChowMein: state => state.menuItems.filter(item => item.type.toLowerCase() === "chow mein"),
    getEuropean: state => state.menuItems.filter(item => item.type.toLowerCase() === "european"),
    getSideDishes: state => state.menuItems.filter(item => item.type.toLowerCase() === "side dishes"),
    getUdon: state => state.menuItems.filter(item => item.type.toLowerCase() === "udon"),
    getSnackBox: state => state.menuItems.filter(item => item.type.toLowerCase() === "snack box"),
    getMunchyBox: state => state.menuItems.filter(item => item.type.toLowerCase() === "munchy box"),

    filteredResults: (state, getters, rootState) => {
        const { activePill } = rootState.PillBarFilter;

        switch (activePill) {
            case 'p-popular':
                return getters.getPopular
            case 'p-appetisers':
                return getters.getAppetisers
            case 'p-saltPepper':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('salt & chilli') ||
                    item.name.toLowerCase().includes('salt & pepper'))
            case 'p-curry':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('curry'))
            case 'p-sweetSour':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('sweet and sour') ||
                    item.name.toLowerCase().includes('sweet & sour'))
            case 'p-chowMein':
                return getters.getChowMein
            case 'p-friedRice':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('fried rice'))
            case 'p-chicken':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('chicken'))
            case 'p-beef':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('beef'))
            case 'p-pork':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('char siu'))
            case 'p-kingPrawn':
                return state.menuItems.filter(item => item.name.toLowerCase().includes('king prawn'))
            case 'p-snackBox':
                return getters.getSnackBox
            case 'p-munchyBox':
                return getters.getMunchyBox
        }
    }
}

const actions = {
    // No need for actions as no data mutations are needed.
    // async fetchMenuData({ commit }) {
    //     commit('setMenu', data)
    // }
}

const mutations = {
    // Not really necessary to mutate any data
    // setMenu: (state, data) => {
    //     state.menuItems = data
    // }
}

export default {
    state,
    getters,
    actions,
    mutations
}
